import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMobile = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.5 4.173c0-.358.3-.673.7-.673h11.6c.4 0 .7.315.7.673v15.654c0 .358-.3.673-.7.673H6.2c-.4 0-.7-.314-.7-.673zM6.2 2C4.998 2 4 2.96 4 4.173v15.654C4 21.04 4.998 22 6.2 22h11.6c1.202 0 2.2-.96 2.2-2.173V4.173C20 2.96 19.002 2 17.8 2zm4.713 14.942a.75.75 0 0 0 0 1.5h2.175a.75.75 0 0 0 0-1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgMobile;
